import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteEcshopAccountsRequestModel, DeleteEcshopAccountsResponseModel } from "@/features/accounts/ecshop/services/delete-accounts-model";

export class DeleteEcshopAccountsApi {
  /**
   * その他連携サービス口座削除API
   */
  public deleteEcshopAccounts = async (
    param: DeleteEcshopAccountsRequestModel
  ): Promise<DeleteEcshopAccountsResponseModel> => {
    const path = `/api/ecshopaccounts/ecshops`;
    const res = await ApiClient.instance.delete<DeleteEcshopAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
